// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import ProtectedRoute from '../../helios/components/common/ProtectedRoute';

/**
 * Route guard Admin Center uses instead of importing Helios'
 * `components/common/ProtectedRoute` directly. Same behavior (redirect to
 * `/login`, preserving the attempted location) — this just keeps the import
 * going through `shared/`, per ADR-0014.
 */
export default function RequireAuth({ children }: { children: React.ReactNode }) {
  return <ProtectedRoute>{children}</ProtectedRoute>;
}
